import React from "react";
import { ArrowRight } from "lucide-react";
import { DAFTAR_URL } from "../../config/links";

export default function CTA() {
    return (
        <section id="daftar" data-testid="cta-section" className="relative py-24 md:py-32">
            <div className="max-w-5xl mx-auto px-6 md:px-12">
                <div className="relative overflow-hidden rounded-[2rem] border border-[#D4AF37]/30 bg-gradient-to-br from-[#111] via-[#0a0a0a] to-[#0c0c0c] p-10 md:p-16 text-center">
                    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.2),transparent_60%)]" />
                    <div className="relative">
                        <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                            Mulai Sekarang
                        </span>
                        <h2 className="mt-4 text-3xl md:text-5xl lg:text-6xl font-medium tracking-tighter text-white">
                            Gabung di{" "}
                            <span className="text-gold-gradient">pusat cuan</span>{" "}
                            hiburan online terpercaya
                        </h2>
                        <p className="mt-6 text-white/70 max-w-2xl mx-auto">
                            Daftarkan akun Anda dalam 1 menit dan akses game online
                            terbaru melalui link resmi terpercaya PUSATCUAN.
                        </p>
                        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                            <a
                                data-testid="final-cta-daftar"
                                href={DAFTAR_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#F3E5AB] text-black font-semibold px-8 py-4 rounded-full transition-all hover:scale-105 shadow-gold-glow-lg"
                            >
                                Daftar Gratis Sekarang
                                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                            </a>
                            <a
                                data-testid="final-cta-contact"
                                href="#faq"
                                className="inline-flex items-center gap-2 text-white/90 border border-white/15 hover:border-[#D4AF37]/60 hover:text-[#D4AF37] px-8 py-4 rounded-full transition-all"
                            >
                                Pelajari Lebih Lanjut
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
